export default __webpack_public_path__ + "static/backgroundArchive-5235078fb9865fad4be8a8f08f1ee130.jpg";